export { default } from './footer-copy';
